import { GetStartedLocalStorageKeys } from '~/pages/GetStarted/common/constants';
import { OnboardingLocalStorageKeys } from '~/pages/Onboarding/onboarding.constants';

export interface ShippoGlobal {
  forceOnboarding(): void;
  forceGetStarted(): void;
  removeForceGetStarted(): void;
}

export class ShippoTools {
  constructor() {
    this.setup();
  }
  private setup() {
    if (!window.shippo) {
      window.shippo = this.buildTools();
    }
  }
  private buildTools(): ShippoGlobal {
    return {
      forceOnboarding: () => {
        localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_COMPLETED);
        localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_LAST_COMPLETED_STEP);
        localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_CURRENT_STEP);
        localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_BUSINESS_TYPE);
        localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_BUSINESS_NEED);
        localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_SHOW_WELCOME_MESSAGE);
        localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_ORDER_MECHANISM);
        localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_ACTIVE_STORE);
        localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_USER_COUNTRY);
        localStorage.setItem(OnboardingLocalStorageKeys.ONBOARDING_ACTIVE, 'true');
        location.reload();
      },
      forceGetStarted: () => {
        localStorage.setItem(GetStartedLocalStorageKeys.FORCE_GET_STARTED, 'true');
        location.assign('/orders');
      },
      removeForceGetStarted: () => {
        localStorage.removeItem(GetStartedLocalStorageKeys.FORCE_GET_STARTED);
        location.assign('/orders');
      },
    };
  }
}
